<template>
    <div>
        <dictionary-simple-table
        dictionary_link = "/product-styles"
        title = "Lista styli Woo"
        :numeral_text = "['styl', 'style', 'styli']"
        :columns_title = "['name']"
        ></dictionary-simple-table>
    </div>
</template>

<script>
    import DictionarySimpleTable from './DictionarySimpleTable.vue';
    export default {
        components: {
            DictionarySimpleTable
        },
    }
</script>